<div class="st-filters-section">
  <div class="st-filters-section-header">
    @if (!customHeaderContentWithFilterButton) {
      <div class="title-section">
        @if (sectionTitle.length) {
          <div class="filter-title">{{ sectionTitle }}</div>
        }
        @if (showTitleTag) {
          <p-tag
            [styleClass]="'severity-' + tagSeverity + ' ' + 'style-light'"
            [value]="tagValue"
          ></p-tag>
        }
      </div>
      <ng-content select="navigation-section"></ng-content>
      @if (showButtons) {
        <div class="filter-toggler-sm-screen d-sm-none">
          <app-button
            [label]="showFilter() ? 'Hide Filters' : 'View Filters'"
            iconStart="icon-funnel-simple"
            (btnClick)="showFilters()"
            [outlinedButton]="true"
            sizeClass="p-button-sm"
            severity="primary"
          >
          </app-button>
        </div>
      }
    } @else {
      <ng-content select="st-filters-section-header-custom"></ng-content>
    }
    @if (showButtons) {
      <div class="search-and-filter-toggle">
        @if (!customHeaderContentWithFilterButton) {
          <div class="k-input-wrapper">
            <span class="left-icon icon-magnifying-glass"></span>
            <input
              type="text"
              pInputText
              placeholder="search.."
              [(ngModel)]="searchModel"
              appDebounceInput
              (debouncedInput)="search($event)"
            />
          </div>
        }
        <app-button
          [label]="!showFilter() ? 'Hide Filters' : 'View Filters'"
          [iconStart]="filterToggleIcon"
          (btnClick)="showFilters()"
          [outlinedButton]="true"
          sizeClass="p-button-sm"
          severity="primary"
        >
        </app-button>
      </div>
    }
  </div>
  <div
    class="filters-containers"
    stCollapsible
    [isCollapsed]="!showFilter()"
    (closed)="formClosed.set($event)"
  >
    <form
      [formGroup]="filterForm"
      (ngSubmit)="submit()"
      [ngStyle]="{
        'flex-flow': filterActionsPlacement === 'start' ? 'row-reverse' : 'row',
      }"
    >
      <div class="filter-inputs">
        @for (filter of filters; track filter) {
          @switch (filter.type) {
            @case ("text") {
              <div class="filter-control">
                <input
                  type="text"
                  pInputText
                  [placeholder]="filter.placeholder"
                  [formControlName]="filter.controlName"
                />
              </div>
            }
            @case ("number") {
              <div class="filter-control">
                <input
                  type="number"
                  class="p-inputtext"
                  [placeholder]="filter.placeholder"
                  [formControlName]="filter.controlName"
                  [attr.min]="filter.minNumber"
                  [attr.max]="filter.maxNumber"
                  (input)="onNumberInput($event, filter)"
                />
              </div>
            }

            @case ("dropdown") {
              <div class="filter-control">
                <p-select
                  appendTo="body"
                  [formControlName]="filter.controlName"
                  [showClear]="filter.clearable"
                  [filter]="filter.enableFilters"
                  [filterBy]="filter.optionLabel"
                  [options]="filter.options"
                  [optionLabel]="filter.optionLabel"
                  [placeholder]="filter.placeholder"
                  [virtualScroll]="filter.hasVirtualScroll"
                  [virtualScrollItemSize]="36"
                  [dropdownIcon]="'icon-caret-up-down'"
                  (onHide)="dropdown.resetFilter()"
                  [group]="filter.hasGroup"
                  #dropdown
                  appAdjustDropdownHeight
                >
                  <ng-template pTemplate="filter" let-options="options">
                    <div class="dropdown-search-box">
                      <div
                        class="p-inputgroup"
                        (click)="$event.stopPropagation()"
                        (keydown.enter)="$event.stopPropagation()"
                      >
                        <input
                          type="text"
                          pInputText
                          ngModel
                          [ngModelOptions]="{ standalone: true }"
                          (keyup)="customFilterFunction($event, options)"
                        />
                        <span class="p-inputgroup-search"
                          ><i class="icon-magnifying-glass"></i
                        ></span>
                      </div>
                    </div>
                  </ng-template>

                  @if (filter.hasGroup) {
                    <ng-template let-group pTemplate="group">
                      <div class="flex align-items-center">
                        <span>{{ group.label }}</span>
                      </div>
                    </ng-template>
                  }

                  <ng-template let-item pTemplate="item">
                    @if (filter.hasSecondLabel) {
                      <div
                        class="flex align-items-start gap-spacing-default flex-column px-spacing-md"
                      >
                        <div
                          class="label-large-regular form-label-color text-start label"
                        >
                          {{ item?.[filter?.optionLabel ?? "label"] }}
                        </div>
                        <div class="flex gap-spacing-2xs">
                          <div
                            class="radius-default background-muted-brand-bg flex justify-content-center align-items-center pt-spacing-3xs"
                            style="width: 16px; height: 16px"
                          >
                            <em
                              [ngClass]="filter.icon || 'icon-phone-solid'"
                              class="icon-brand-color flex align-items-center"
                              style="font-size: 10px"
                            ></em>
                          </div>
                          <span
                            class="body-small-regular form-text-help-color label"
                          >
                            {{ item?.[filter?.secondLabel ?? ""] }}
                          </span>
                        </div>
                      </div>
                    } @else {
                      <div class="gap-spacing-xs flex-column">
                        {{ item?.[filter?.optionLabel ?? "label"] }}
                      </div>
                    }
                  </ng-template>
                </p-select>
              </div>
            }
            @case ("groupSelect") {
              <p-select
                appendTo="body"
                [group]="true"
                [formControlName]="filter.controlName"
                [showClear]="filter.clearable"
                [options]="filter.options"
                [filter]="filter.enableFilters"
                [filterBy]="filter.optionLabel"
                [optionLabel]="filter.optionLabel"
                [placeholder]="filter.placeholder"
                [virtualScroll]="filter.hasVirtualScroll"
                [virtualScrollItemSize]="36"
                [dropdownIcon]="'icon-caret-up-down'"
                appAdjustDropdownHeight
              >
                <ng-template let-group pTemplate="group">
                  <div class="flex align-items-center group-name">
                    {{ group.label }}
                  </div>
                </ng-template>
              </p-select>
            }
            @case ("cascadeSelect") {
              <div class="filter-control">
                <p-cascadeSelect
                  [options]="filter.options ? filter.options : []"
                  [formControlName]="filter.controlName"
                  optionGroupLabel="label"
                  [placeholder]="filter.placeholder"
                  optionLabel="label"
                  [optionGroupChildren]="['items']"
                  appendTo="body"
                />
              </div>
            }
            @case ("multiSelect") {
              <div class="filter-control">
                <p-multiSelect
                  appendTo="body"
                  [formControlName]="filter.controlName"
                  [options]="filter.options"
                  [optionLabel]="filter.optionLabel"
                  [placeholder]="filter.placeholder"
                  [showClear]="true"
                  [filter]="true"
                  [filterBy]="filter.optionLabel"
                  [virtualScroll]="true"
                  [virtualScrollItemSize]="36"
                  [dropdownIcon]="'icon-caret-up-down'"
                  appAdjustDropdownHeight
                />
              </div>
            }
            @case ("checkbox") {
              <div class="filter-control">
                <p-checkbox
                  [formControlName]="filter.controlName"
                  [value]="true"
                  [inputId]="filter.controlName"
                />
              </div>
            }
            @case ("time") {
              <div class="filter-control">
                <p-datepicker
                  appendTo="body"
                  [formControlName]="filter.controlName"
                  [placeholder]="filter.placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="false"
                  [timeOnly]="true"
                  [inputId]="filter.controlName"
                />
              </div>
            }
            @case ("date") {
              <div class="filter-control">
                <p-datepicker
                  [formControlName]="filter.controlName"
                  [placeholder]="filter.placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  icon="icon-calendar-blank"
                  [inputId]="filter.controlName"
                  appendTo="body"
                  [minDate]="filter.minDate"
                  [maxDate]="filter.maxDate"
                />
              </div>
            }
          }
          @if (filter.type === "timeRange" && filter.rangeFilterReferences) {
            <div class="filter-control">
              <div class="timeRange" [formGroupName]="filter.controlName">
                <p-datepicker
                  #fromTime
                  [formControlName]="
                    filter.rangeFilterReferences[0].controlName
                  "
                  [placeholder]="filter.rangeFilterReferences[0].placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="false"
                  [timeOnly]="true"
                  inputId="time-range-from"
                  [className]="'time-range-from'"
                  appendTo="body"
                  [minDate]="filter.minDate"
                  [maxDate]="filter.maxDate"
                />
              </div>
            </div>
            <div class="filter-control">
              <div class="timeRange" [formGroupName]="filter.controlName">
                <p-datepicker
                  [formControlName]="
                    filter.rangeFilterReferences[1].controlName
                  "
                  [placeholder]="filter.rangeFilterReferences[1].placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="false"
                  [timeOnly]="true"
                  inputId="time-range-to"
                  [className]="'time-range-from'"
                  appendTo="body"
                  [minDate]="filter.minDate"
                  [maxDate]="filter.maxDate"
                />
              </div>
            </div>
          }
          @if (filter.type === "dateRange" && filter.rangeFilterReferences) {
            <div class="filter-control">
              <div class="dateRange" [formGroupName]="filter.controlName">
                <p-datepicker
                  appendTo="body"
                  #fromDate
                  [formControlName]="
                    filter.rangeFilterReferences[0].controlName
                  "
                  [placeholder]="filter.rangeFilterReferences[0].placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  [maxDate]="filter.maxDate | stMaxDate: toFromDate.value"
                  inputId="date-range-from"
                  icon="icon-calendar-blank"
                />
              </div>
            </div>
            <div class="filter-control">
              <div class="dateRange" [formGroupName]="filter.controlName">
                <p-datepicker
                  appendTo="body"
                  #toFromDate
                  [minDate]="fromDate.value"
                  [formControlName]="
                    filter.rangeFilterReferences[1].controlName
                  "
                  [placeholder]="filter.rangeFilterReferences[1].placeholder"
                  [iconDisplay]="'input'"
                  [showIcon]="true"
                  inputId="date-range-to"
                  icon="icon-calendar-blank"
                />
              </div>
            </div>
          }
        }
      </div>
      <div
        class="filter-actions {{ isButtonColumnLayout }}"
        [ngClass]="
          isButtonColumnLayout ? 'button-column-layout' : 'button-row-layout'
        "
      >
        <app-button
          [label]="clearButtonText"
          (btnClick)="clearFilters()"
          sizeClass="p-button-sm"
          severity="secondary"
          [outlinedButton]="true"
        />

        <app-button
          [label]="ApplyButtonText"
          (btnClick)="submit()"
          [disabled]="isApplyButtonDisabled"
          sizeClass="p-button-sm"
          severity="primary"
        />
      </div>
    </form>
  </div>
  @if (isApplied() && filterResults.length) {
    <div class="filters-result">
      @if (numberOfResults > 0) {
        <div class="result-counter">
          <div class="result-counter-content">
            <span>{{ numberOfResults }}</span
            ><span>{{ numberOfResults === 1 ? "Result" : "Results" }}</span>
          </div>
        </div>
      }
      <div class="filters-result-items">
        @for (item of filterResults; track item.value; let i = $index) {
          <div class="filters-result-item">
            <span class="label">{{ item.label }}</span>
            <span class="value">
              <span class="text">{{ item.value }}</span>
              @if (item.clearable) {
                <span
                  (click)="
                    removeSelectedFilter(item.moreInformation.controlName, i)
                  "
                  (keydown.enter)="
                    removeSelectedFilter(item.moreInformation.controlName, i)
                  "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                  >
                    <path
                      d="M8.80864 3.20605L3.48657 8.52812"
                      stroke="#94A3B8"
                      stroke-width="0.665259"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M3.48657 3.20605L8.80864 8.52812"
                      stroke="#94A3B8"
                      stroke-width="0.665259"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </span>
              }
            </span>
          </div>
        }
      </div>
      <div class="clear-section">
        <button type="button" (click)="clearResults()" class="cursor-pointer">
          Clear
        </button>
      </div>
    </div>
  }
</div>
